import { render, staticRenderFns } from "./BitrixExportLotItem.vue?vue&type=template&id=a70d4416&scoped=true"
import script from "./BitrixExportLotItem.vue?vue&type=script&lang=js"
export * from "./BitrixExportLotItem.vue?vue&type=script&lang=js"
import style0 from "./BitrixExportLotItem.vue?vue&type=style&index=0&id=a70d4416&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70d4416",
  null
  
)

export default component.exports